import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-left" }, " Total ", -1)
const _hoisted_2 = [
  _hoisted_1
]

import { tail } from 'lodash';

import { ColumnDefinition, Sticky } from '@/components/_global/BalTable/types';

type Props = {
  isColumnStuck?: boolean;
  onRowClick?: (data: any) => void;
  sticky?: Sticky;
  columns: ColumnDefinition<any>[];
};


export default /*#__PURE__*/_defineComponent({
  props: {
    isColumnStuck: { type: Boolean },
    onRowClick: null,
    sticky: null,
    columns: null
  },
  setup(__props: any) {

const props = __props as {
  isColumnStuck?: boolean;
  onRowClick?: (data: any) => void;
  sticky?: Sticky;
  columns: ColumnDefinition<any>[];
}



/** FUNCTIONS */
// Need a method for horizontal stickiness as we need to
// check whether the table item belongs in the first column
function getHorizontalStickyClass(index: number) {
  if (index !== 0) return '';
  if (props.sticky === 'horizontal' || props.sticky === 'both') {
    return 'horizontalSticky';
  }
  return '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tbody", null, [
    _createElementVNode("tr", {
      class: _normalizeClass([
        'bg-white z-10 row-bg group',
        { 'cursor-pointer': !!props.onRowClick },
      ])
    }, [
      _createElementVNode("td", {
        class: _normalizeClass([
          getHorizontalStickyClass(0),
          __props.isColumnStuck ? 'isSticky' : '',
          'text-left p-6 bg-white dark:bg-gray-850 border-t dark:border-gray-900 align-top',
        ])
      }, _hoisted_2, 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tail)(__props.columns), (column, columnIndex) => {
        return (_openBlock(), _createElementBlock("td", {
          key: column.id,
          class: _normalizeClass([
          column.align === 'right' ? 'text-left' : 'text-right',
          getHorizontalStickyClass(columnIndex + 1),
          __props.isColumnStuck ? 'isSticky' : '',
          'p-6 bg-white dark:bg-gray-850 border-t dark:border-gray-900',
        ])
        }, [
          (column.totalsCell)
            ? _renderSlot(_ctx.$slots, column.totalsCell, { key: 0 })
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ], 2)
  ]))
}
}

})